import {DialogContent} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'

import {theme} from '../theme'

const styles = {
  root: {
    padding: theme.spacing(1.5, 3),
    '&:first-child': {
      paddingTop: theme.spacing(3),
    },
    '&:last-child': {
      paddingBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      flex: 'none',
      width: '100%',
      justifySelf: 'center',
      padding: theme.spacing(0, 2),
      '&:first-child': {
        paddingTop: theme.spacing(1),
      },
      '&:last-child': {
        paddingBottom: theme.spacing(0),
      },
    },
  },
}

export default withStyles(styles, {name: 'LPCDialogContent'})(DialogContent)
